import { render, staticRenderFns } from "./DatasetWidget.vue?vue&type=template&id=77ff4928&scoped=true&"
import script from "./DatasetWidget.vue?vue&type=script&lang=js&"
export * from "./DatasetWidget.vue?vue&type=script&lang=js&"
import style0 from "./DatasetWidget.vue?vue&type=style&index=0&id=77ff4928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ff4928",
  null
  
)

export default component.exports